import * as _ from "lodash";

import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { TerminalGroupConfiguration } from "./editingConfiguration.reducer";
import { SelectedGroupsByProgressive } from "../models/SelectedGroupsByProgressive";

export interface TerminalGroupState {
    terminalGroups: TerminalGroupConfiguration[];
    selected: SelectedGroupsByProgressive;
}

const initialState: TerminalGroupState = {
    terminalGroups: [],
    selected: {
        progressive: [],
        /*proportional: [],
        normal: [],
        levels: [],
        multipots: [],
        easylink: [],
        sap: [],*/
        mr_champion: [],
        pig_boom: []
    }
};

export function terminalGroupsReducer(
    state: TerminalGroupState = initialState,
    action: Action
): TerminalGroupState {
    let newState: TerminalGroupState;
    switch (action.type) {
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return initialState;
        case ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG:
            newState = _.cloneDeep(state);
            if (
                (!action.payload.type ||
                    action.payload.type !== "Game_Group") &&
                (newState.terminalGroups.length !== 0 ||
                    action.payload.config.length !== 0)
            ) {
                newState.terminalGroups = action.payload.config;
                return newState;
            }
            return state;
        case ConfigurationsActionTypes.SELECT_GROUP_TYPE:
            /*if ((action.payload.groupType = "terminal")) {
                return initialState;
            }
            newState = _.cloneDeep(state);*/
            return state; //initialState;
        case ConfigurationsActionTypes.UPDATE_PROGRESSIVES_CONFIG:
        case ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG:
            newState = _.cloneDeep(state);
            if (action.payload.groupType === "terminal") {
                newState.selected = action.payload.config.reduce(
                    (acc, curr) => {
                        let { terminal_groups: newlySelectedGroups, type } =
                            curr;
                        if (
                            type == "multipots" ||
                            type == "jumbolink" ||
                            type == "luckytokenslink" ||
                            type == "levels" ||
                            type == "reelstrike" ||
                            type == "easylink" ||
                            type == "sap"
                        ) {
                            newlySelectedGroups = [];
                            curr.children.forEach(child => {
                                if (child.terminal_groups !== undefined) {
                                    newlySelectedGroups =
                                        newlySelectedGroups.concat(
                                            child.terminal_groups
                                        );
                                }
                            });
                        }

                        let terminalGroup: TerminalGroupConfiguration;

                        newlySelectedGroups.forEach(
                            (newlySelectedGroup: string) => {
                                terminalGroup = findTerminalGroupById(
                                    newState,
                                    newlySelectedGroup
                                );

                                let typeKey =
                                    type == "fractionated" ||
                                    type == "multipots" ||
                                    type == "jumbolink" ||
                                    type == "luckytokenslink" ||
                                    type == "levels" ||
                                    type == "reelstrike" ||
                                    type == "easylink" ||
                                    type == "sap" ||
                                    type == "normal" ||
                                    type == "proportional"
                                        ? "progressive"
                                        : type;
                                acc[typeKey].push(terminalGroup);
                            }
                        );
                        return acc;
                    },
                    {
                        progressive: [],
                        /*proportional: [],
                        normal: [],
                        levels: [],
                        multipots: [],
                        easylink: [],
                        sap: [],*/
                        mr_champion: [],
                        pig_boom: []
                    }
                );
            }
            return newState;
        case ConfigurationsActionTypes.CLEAN_GROUP_TYPES:
            if (action.payload.selectedType == "game") {
                return {
                    ...initialState,
                    terminalGroups: state.terminalGroups
                };
            } else if (state.terminalGroups.length > 0) {
                // Clean non-existant from selected
                newState = _.cloneDeep(state);
                Object.keys(state.selected).map(key => {
                    if (state.selected[key].length > 0) {
                        let newSelected = state.selected[key].filter(
                            selectedGroup => {
                                return !state.terminalGroups.includes(
                                    selectedGroup
                                )
                                    ? false
                                    : true;
                            }
                        );
                        newState.selected[key] = newSelected;
                    }
                });
                return newState;
            }
        default:
            return state;
    }
}

/**
 * Auxiliary function that returns the TerminalGroupConfiguration object that
 * matches the description provided.
 * @param state { TerminalGroupState }
 * @param id { string }
 * @returns TerminalGroupConfiguration
 */
function findTerminalGroupById(
    state: TerminalGroupState,
    id: string
): TerminalGroupConfiguration {
    return state.terminalGroups.find(group => group.id == id);
}
